export default [
  {
    path: "/expenses",
    name: "expenses-list",
    meta: {
      title: "Список расходов",
      authRequired: true,
    },
    component: () => import("@/modules/expenses/views/items.vue"),
  },
  {
    path: "/expenses/:id",
    name: "expenses-edit",
    meta: {
      title: "Расход",
      authRequired: true,
    },
    component: () => import("@/modules/expenses/views/edit.vue"),
  },
  {
    path: "/expenses/new",
    name: "expenses-create",
    meta: {
      title: "Расход",
      authRequired: true,
    },
    component: () => import("@/modules/expenses/views/edit.vue"),
  },
];
